/**
 * Soft protections against casual download of card media (backend uploads).
 * Hides native control download where supported; blocks image drag / save-as menu.
 * Not DRM — determined users can still capture URLs.
 */

import type { CSSProperties, MouseEvent, SyntheticEvent } from "react";

/** Native `<video>` / `<audio controls>` — hide browser Download. */
export const CARD_MEDIA_CONTROLS_LIST = "nodownload";

export function ensureMediaNoDownload(el: HTMLMediaElement | null | undefined) {
  if (!el || typeof el.getAttribute !== "function") return;
  const existing = el.getAttribute("controlsList") || "";
  if (/\bnodownload\b/i.test(existing)) return;
  el.setAttribute(
    "controlsList",
    existing.trim()
      ? `${existing.trim()} ${CARD_MEDIA_CONTROLS_LIST}`
      : CARD_MEDIA_CONTROLS_LIST,
  );
}

/** Prevent right-click “Save image as…” on card photos. */
export function preventCardMediaContextMenu(
  event: MouseEvent | SyntheticEvent,
) {
  event.preventDefault();
}

/** Props for `<img>` / MUI `component="img"` showing backend card media. */
export const cardProtectedImageProps = {
  draggable: false as const,
  onContextMenu: preventCardMediaContextMenu,
};

/** CSS to discourage drag-save of protected images. */
export const cardProtectedImageSx = {
  WebkitUserDrag: "none",
  userSelect: "none",
} as const;

export const cardProtectedImageStyle: CSSProperties = {
  // Vendor property — not in React's CSSProperties typings
  ...({ WebkitUserDrag: "none" } as CSSProperties),
  userSelect: "none",
};
